import { VideoStream } from '../components/types/videos';
import { ConnectedUser } from '../stores/types/connection';
import { Subscribers } from './video/opentok-connection';

declare global {
	/* eslint-disable-next-line no-unused-vars */
	interface Window {
		webkitAudioContext: typeof AudioContext;
		localRtcId?: string;
		debugOT: {
			printOTDebugLogForStreamId: Function;
			connectedPresenterVideos?: VideoStream[] | null;
			connectedUsers?: ConnectedUser[] | null;
			subscribers?: Subscribers | null;
			resubscribes?: any | null;
			subscribes?: any | null;
			unsubscribes?: any | null;
		};
		AudioContext: AudioContext,
		process: any;
	}
}

export default class AudioAnalyser {
	context: AudioContext;

	stream: MediaStream;

	node: MediaStreamAudioSourceNode;

	gain: GainNode;

	analyzer: AnalyserNode;

	/* eslint-disable-next-line no-unused-vars */
	listener: (avg: number) => void;

	interval: any;

	/* eslint-disable-next-line no-unused-vars */
	constructor(stream: MediaStream, listener: (avg: number) => void, interval?: number) {
		this.listener = listener;
		// @ts-ignore - https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/AudioContext#sinkid
		this.context = new AudioContext({ sinkId: { type: 'none' } });
		this.stream = stream;
		this.node = this.context.createMediaStreamSource(this.stream);
		this.gain = this.context.createGain();
		this.analyzer = this.context.createAnalyser();
		this.analyzer.fftSize = 32;
		this.node.connect(this.gain);
		this.gain.connect(this.analyzer);
		this.interval = setInterval(this.getLevel, interval || 60);
	}

	getLevel = (): void => {
		const volArray = new Uint8Array(32);
		this.analyzer.getByteTimeDomainData(volArray);
		let avg = 0;

		avg += volArray[2] - 128;
		avg += volArray[10] - 128;
		avg += volArray[25] - 128;

		avg /= 3;

		this.listener(Math.abs(avg));
	};

	public destroy = () => {
		clearInterval(this.interval);

		// Release old audio resources
		this.context.close();
	};
}
